<template>
  <div class="body-portal-host">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BodyPortal",
  data() {
    return {
      originalParent: null,
      originalNextSibling: null,
      movedToBody: false,
    };
  },
  mounted() {
    if (typeof document === "undefined" || !this.$el) return;
    this.originalParent = this.$el.parentNode;
    this.originalNextSibling = this.$el.nextSibling;
    document.body.appendChild(this.$el);
    this.movedToBody = true;
  },
  beforeDestroy() {
    if (!this.$el || !this.movedToBody) return;
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
};
</script>

<style scoped>
.body-portal-host {
  position: static;
}
</style>
